import IControl = mapboxgl.IControl;
import Connector from 'connect-store';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import mapStore from '../../storeInstances/mapStore';
import GraphInfoPanelView from '../../views/graphInfoPanelView/GraphInfoPanelView';

export default class OriginalPointsLegendControl implements IControl {
  private _container: HTMLDivElement = document.createElement('div');

   public onAdd() {
    ReactDOM.render(
      <Connector store={mapStore} View={GraphInfoPanelView}/>,
      this._container,
    );
    return this._container;
  }

  public onRemove() {
    this._container.parentNode!.removeChild(this._container);
  }

  public getDefaultPosition() {
    return 'top-right';
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/classes/controls/GraphInfoPanelControl.tsx